export interface ChangelogEntry {
  version: string;
  date: string;
  title: string;
  changes: string[];
}

export const changelog: ChangelogEntry[] = [
  {
    version: 'v0.8.0',
    date: '2026-02-21',
    title: 'Version Channels + QoL',
    changes: [
      'Channel-aware storage — canary and stable settings no longer bleed across deploys',
      'Gate "Remember me" — skip the password for 7 days on trusted browsers',
      'Channel badge in status bar — amber tag shows when running a preview build',
      'Channel switcher in Updates modal — jump between stable and canary',
      'Changelog backfill — in-app changelog now covers v0.4.0 through v0.8.0',
      'Version check URL fix — polling now respects BASE_URL for subdirectory deploys',
    ],
  },
  {
    version: 'v0.7.3',
    date: '2026-02-20',
    title: 'Relay Hardening + Poly Orders',
    changes: [
      'Polymarket open orders sorting + value column',
      'Relay WebSocket URL auto-derives from window.location.host in production',
      'Whitelisted gamma-api.polymarket.com in relay production host allowlist',
      'SPA deep-link refresh fix — absolute asset paths',
      'Multi-origin CORS support in relay',
    ],
  },
  {
    version: 'v0.7.2',
    date: '2026-02-20',
    title: 'Viewport + Sloop Access',
    changes: [
      'Viewport dashboard — visual status page for humans at /relay/viewport',
      'Sloop access — Brendan can push/pull and auto-deploy',
      'Deploy router — branch-specific post-receive hooks',
      'Forge email — forge@dev.g1.newbx.com for team notifications',
    ],
  },
  {
    version: 'v0.7.1',
    date: '2026-02-20',
    title: 'Sidecar Access',
    changes: [
      'Sidecar endpoint — server-rendered HTML dashboard for LLM agents',
      'Rotos integration — rotation numbers from Unabated feed via PostgreSQL',
      'CBB rotation numbers — college basketball games now have rotation numbers',
      'MLB support — enabled as a first-class sport',
      'Odds API retired — replaced by server-side rotos service',
    ],
  },
  {
    version: 'v0.5.0',
    date: '2026-02-19',
    title: 'Stabilization + Order Books',
    changes: [
      'In-app diagnostics page — 12 health checks across 5 categories',
      '53 unit/integration tests — critical-path coverage',
      'Date navigator — date picker + prev/next/today/all buttons',
      'Exchange-style order book panel with sweep depth',
      'Build commit hash in status bar for deploy verification',
      'Auto-snap race condition fix',
    ],
  },
  {
    version: 'v0.4.0',
    date: '2026-02-18',
    title: 'Auto-Deploy + Book Sweep',
    changes: [
      'Auto-deploy on push + stale tab version check banner',
      'Refresh cache button in sidebar (preserves credentials)',
      'Book sweep — Shift+click stages sweep with IOC execution',
      'Order book dollar columns (Cost + Depth $)',
      'Default chronological sort + 12h Vegas time display',
    ],
  },
  {
    version: 'v0.3.1',
    date: '2026-02-18',
    title: 'Stability & Auto-Deploy',
    changes: [
      'Inline book panel moved into table row expansion (no more sidebar)',
      'Polymarket outcome token ordering verified from Gamma API',
      'Auto-deploy pipeline — push to staging triggers build + deploy',
      'Stale tab detection — banner prompts reload on new deploy',
      'Refresh cache button in sidebar',
      'Rotation number column limit fix',
      'Queue position polling spam fix',
    ],
  },
  {
    version: 'v0.3.0',
    date: '2026-02-17',
    title: 'Inline Trading',
    changes: [
      'Inline book panel — click game row to show order book',
      'Book sweep — Shift+click odds to stage a sweep order (IOC)',
      'Order book dollar columns (cost + depth $)',
      'Dollar risk/win display on odds cells',
      'Odds API client with rotation numbers and sportsbook odds',
      'Sortable rotation number column on all tables',
      'Odds click opens inline panel (not page navigation)',
    ],
  },
  {
    version: 'v0.2.0',
    date: '2026-02-15',
    title: 'Multi-Sport Odds',
    changes: [
      'NBA + CBB value dashboard with consolidated moneyline tables',
      'Side-by-side Polymarket odds (spreads, totals, moneylines)',
      'Sport hotkeys and click-to-trade from table cells',
      'Inline order quantity editing and unified odds display',
      'Column sorting on all sports table headers',
      'Default chronological sort + 12-hour Vegas time',
      'CBB date filter fix (UTC → local)',
      'Kalshi API deep audit — status filter, pagination, sorting',
    ],
  },
  {
    version: 'v0.1.0',
    date: '2026-02-10',
    title: 'The Big Bang',
    changes: [
      'Trading terminal with Kalshi + Polymarket integration',
      'Market explorer with real-time candlestick charts',
      'Position tracker with P&L calculation',
      'Order management (place, cancel, monitor fills)',
      'RSA-PSS authentication via WebCrypto',
      'Light/dark theme with fintech aesthetic',
      'Credential profiles for multiple accounts',
    ],
  },
];

export const CURRENT_VERSION = changelog[0].version;
